import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ProgressBar.html?raw';
import on from 'dojo/on';
import { ToasterHelpers, TranslationHelpers } from "../../../more/Helpers";
import domConstruct from 'dojo/dom-construct';


type DisplayType = "minimal" | "modal" | "toast";

interface ProgressBarConstructorProps {
    displayType?: "minimal" | "modal" | "toast",
    heading?: string,
    textlinesCount?: number
    initialText?: string;
    destroyAfterCompletion?: boolean;
    allowCancel?: boolean;
    noResponseTimeout?: number;
}
class ProgressBar extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private progressLabel: HTMLElement;
    private messageContainer: HTMLElement;
    private barContainer: HTMLElement;
    private bar: HTMLElement;
    private modalContainer: HTMLDialogElement;
    private dialogHeader: HTMLElement;
    private dialogContent: HTMLElement;
    private noResponseOverlay: HTMLElement;
    private containerModalCloseBtn: HTMLElement;
    private btnClose: HTMLElement;
    private btnCancel: HTMLElement;

    private currentWidth: number = 0;
    private targetWidth: number = 0;
    private stepSpeed: number = 100;
    private duration: number = 1200;

    private noResponseTimeout: number = 10000;
    private displayType: DisplayType = "minimal";
    private textLinesCount: number = 1;
    private allowCancel: boolean = false;
    private textLines: Array<{ node: HTMLElement, text: string }> = null;
    private previousMessage: string = null;

    private _noResponseHandle: any = null;
    private _destroyHandle: any = null;
    private _initialText: string = null;

    private _initialParent: HTMLElement = null;

    allowDecrementation: boolean = false;
    destroyAfterCompletion: boolean = true;

    constructor(params?: ProgressBarConstructorProps) {
        super(...(arguments as unknown as []));

        if (params?.initialText) {
            this._initialText = params.initialText;
            /*this.previousMessage = this._initialText;*/
        }
    }

    _setDisplayTypeAttr(type: DisplayType) {
        if (this.displayType) this.UiModder.domClass.remove(this.domNode, this.displayType);

        this.displayType = type;

        this.UiModder.domClass.add(this.domNode, this.displayType);

        if (type == "modal") {
            //this.UiModder.domAttr.set(this.modalContainer, "open", "true");
            //this.modalContainer.attributes.setNamedItem("open" as any);
            this.UiModder.domConstruct.place(this.barContainer, this.dialogContent);
            this.UiModder.domConstruct.place(this.messageContainer, this.dialogContent);
            this.UiModder.domConstruct.place(this.noResponseOverlay, this.modalContainer);

            ToasterHelpers.removeToast(this.id);
        } else if (type == "toast") {


            // TOASTMODUS WIP - funzt noch nicht ordentlich!!

            this._initialParent = document.body;

            let toasterButtons = [];

            this.UiModder.domConstruct.place(this.barContainer, this.dialogContent);
            this.UiModder.domConstruct.place(this.messageContainer, this.dialogContent);


            toasterButtons.push({
                label: "aufmachen",
                callback: lang.hitch(this, this._onOpenModalFromToast),
                icon: "fas fa-external-link"
            });

            if (this.allowCancel) {
                toasterButtons.push({
                    label: "General_Cancel",
                    callback: lang.hitch(this, this._onCancelDialog),
                    icon: "fas fa-ban"
                });
            }
            let toastID = ToasterHelpers.showToast({
                title: this.dialogContent,
                ID: this.id,
                showClose: !this.destroyAfterCompletion,
                timeout: "permanent",
                options: {
                    buttons: toasterButtons
                }
            });
        }
        else {
            /*this.textLinesCount = 1;*/
        }
    }

    private _onOpenModalFromToast() {
        domConstruct.place(this.domNode, this._initialParent, "first");

        this._setDisplayTypeAttr("modal");

        this._showModal();
    }

    private _showModal() {
        (this.modalContainer as any).showModal();

        this.hideNode(this.containerModalCloseBtn, !this.allowCancel);
        this.hideNode(this.btnCancel, !this.allowCancel);
    }

    _setTextlinesCountAttr(count: number) {
        if (!count) count = 1;

        this.textLinesCount = count;
    }

    _setHeadingAttr(heading: string) {
        if (heading) {
            heading = TranslationHelpers.tryTranslate(heading);
            this.dialogHeader.innerHTML = heading;
            this.hideNode(this.dialogHeader, false);
        } else {
            this.hideNode(this.dialogHeader, true);
        }
    }

    /**
     * Neues Progressziel angeben
     * @param targetprogress Fortschritt, 0-100
     * @param message Optional: Nachricht für den aktuellen Fortschritt. Wenn nicht angegeben (undefined oder null): keine Änderung. Wenn leer: Bestehende Nachrichten werden entfernt.
     */
    setNewTarget(targetprogress: number, message?: string) {
        //if (typeof stepSpeed == "number") {
        //    this.stepSpeed = stepSpeed;
        //}

        //console.debug(this.id + " setNewTarget", targetprogress, message);


        if (typeof (targetprogress) != "number" || targetprogress > 100 || targetprogress < 0) {
            return;
        }

        if (this._destroyed) return;

        if (this._destroyHandle) clearTimeout(this._destroyHandle);

        targetprogress = Math.floor(targetprogress);

        if (typeof (message) == "string") {
            if (message != "") {
                this.hideNode(this.messageContainer, false);

                if (this.previousMessage != message) {

                    this.previousMessage = message;

                    while (this.textLines.length >= this.textLinesCount) {
                        let firstline = this.textLines.shift();
                        if (firstline) this.UiModder.domConstruct.destroy(firstline.node);
                    }

                    let node = this.UiModder.domConstruct.create("p", {
                        className: "progressText",
                        innerHTML: message
                    }, this.messageContainer);

                    this.textLines.push({ node: node, text: message });

                    this.messageContainer.scrollTo({ top: this.messageContainer.scrollHeight, behavior: "smooth" });
                }
            } else {
                //this.hideNode(this.messageContainer);
                this.textLines.forEach(entry => lang.hitch(this, this.UiModder.domConstruct.destroy, entry.node));
                this.textLines = [];
            }
        } 


        if (this.targetWidth >= targetprogress && this.allowDecrementation != true) return;

        if (this._incrementTimeout) {
            clearTimeout(this._incrementTimeout);
            this._incrementTimeout = null;
        }

        if (this._fadeoutTimeout) {
            clearTimeout(this._fadeoutTimeout);
            this._fadeoutTimeout = null;
        }

       

        this.targetWidth = targetprogress;

        this.UiModder.domClass.toggle(this.domNode, "full", this.targetWidth >= 100);
        this.UiModder.domClass.toggle(this.domNode, "null", this.targetWidth <= 0);

        // anhand der nötigen Schritte und der Stepspeed die Komplettdauer für die Animation berechnen:
        let diff = Math.abs(this.targetWidth - this.currentWidth);
        let stepWidth = 0;
        this.stepSpeed = 0;
        const minStepSpeed = 50;
        while (this.stepSpeed < minStepSpeed) {
            stepWidth++;
            this.stepSpeed = diff != 0 ? (this.duration * stepWidth) / (diff) : minStepSpeed;
        }

        this.stepSpeed = this.stepSpeed * 0.8; // Textupdates bisschen schneller machen wirkt besser!
        

        this.domNode.style.setProperty("--animationDuration", this.duration.toString() + "ms");

        this.domNode.style.setProperty("--progress", this.targetWidth <= 100 ? this.targetWidth + "%" : "100%");

        if (this.targetWidth != this.currentWidth) {
            let step = this.targetWidth < this.currentWidth ? -1 * stepWidth : stepWidth;

            this.incrementStep(step);

            this.UiModder.domClass.remove( this.progressLabel, "hidden");
        }

        //console.debug(this.id + " stepspeed", this.stepSpeed, diff);
    }

    private _incrementTimeout: any = null;
    private _fadeoutTimeout: any = null;
    private isMouseEntered: boolean = false;

    private incrementStep(step: number = 1) {
        if (this._destroyed == true) return;

        //if (this.currentWidth == 100) debugger;
        if (this.stepSpeed <= 0) {
            this.currentWidth = this.targetWidth;
        } else {
            this.currentWidth = this.currentWidth + step;
        }

        if (this._noResponseHandle) {
            clearTimeout(this._noResponseHandle);
            this._noResponseHandle = null;
        }

        this.UiModder.domClass.remove(this.domNode, "noResponse");

        //this.domNode.style.setProperty("--progressLabel", this.currentWidth + "%");
        this.progressLabel.innerHTML = this.currentWidth + "%";

        this.UiModder.domClass.toggle(this.domNode, "leftLabel", this.currentWidth > 85);
        this.fadeinProgressLabel();

        if (this.currentWidth != this.targetWidth) {
            if (step < 0 && this.currentWidth + step < this.targetWidth) {
                step = -1;
            }
            else if (step > 0 && this.currentWidth + step > this.targetWidth) {
                step = 1;
            }
            this._incrementTimeout = setTimeout(lang.hitch(this, this.incrementStep, step), this.stepSpeed);
        } else {
            this.fadeoutProgressLabel();
        }

        if (this.currentWidth == 100) {
            this.emit("finished");
            if (this.destroyAfterCompletion === true) {
                this._destroyHandle = setTimeout(lang.hitch(this, this.destroy), this.duration * 1.1);
            } 
        } else {
            this._noResponseHandle = setTimeout(lang.hitch(this, this._onNoResponse), this.noResponseTimeout);
        }
    }

    private fadeinProgressLabel() {
        this.UiModder.domClass.remove(this.progressLabel, "hidden");

        if (this._fadeoutTimeout) {
            clearTimeout(this._fadeoutTimeout);
            this._fadeoutTimeout = null;
        }
    }

    private fadeoutProgressLabel() {
        if (this._fadeoutTimeout) {
            clearTimeout(this._fadeoutTimeout);
            this._fadeoutTimeout = null;
        }

        if (this.currentWidth >= 100 && this.displayType == "modal") {
            if (this.destroyAfterCompletion == true) {
                this.hideDialog();
            } else {
                this.hideNode(this.containerModalCloseBtn, false);
                this.hideNode(this.btnClose, false);
                this.hideNode(this.btnCancel);
            }
        }


        if (this.isMouseEntered === true || this.targetWidth != this.currentWidth) {
            return;
        }

        this._fadeoutTimeout = setTimeout(lang.hitch(this, this.UiModder.domClass.add, this.progressLabel, "hidden"), 1000);

    }

    close() {
        this.hideDialog();
    }

    private hideDialog() {
        if (this.displayType == "modal") {
            (this.modalContainer as any).close();
            this.emit("closed");

            if (this.isNotResponding) {
                this._destroyHandle = setTimeout(lang.hitch(this, this.destroy), 5000);
            }
        }

        ToasterHelpers.removeToast(this.id);

    }

    private _onNoResponse() {
        this.UiModder.domClass.add(this.domNode, "noResponse");
        this._noResponseHandle = null;
    }

    private _onClick_Cancel(evt: MouseEvent) {
        this.emit("cancel");
        this.hideDialog();
    }
    
    private _onClick_CloseModal(evt: MouseEvent) {
        this.hideDialog();
    }

    private _onMouseEnter(evt: MouseEvent) {
        this.isMouseEntered = true;
        this.fadeinProgressLabel();
    }

    private _onMouseLeave(evt: MouseEvent) {
        this.isMouseEntered = false;
        this.fadeoutProgressLabel();
    }

    private _onTouchStart(evt: TouchEvent) {
        this.isMouseEntered = true;
        this.fadeinProgressLabel();
    }

    private _onTouchEnd(evt: TouchEvent) {
        this.isMouseEntered = false;
        this.fadeoutProgressLabel();
    }

    private _onClick(evt: MouseEvent) {
        if (this.isNotResponding()) {
            if (this.displayType == "modal") {
                this.hideDialog();
            }
        }
    }

    private isNotResponding(): boolean {
        return this.currentWidth != 100 && this._noResponseHandle == null;
    }

    private _onCancelDialog(evt: Event) {

        // beim escape kommen wir hierher. gut überlegen ob es schlau ist den Dialog offen zu erzwingen!
        if (this.isNotResponding() == false) {
            // also wenn es responding IST
            evt.preventDefault();
        }

        if (this.currentWidth == 100 && this.destroyAfterCompletion != true && this.displayType == "modal") {
            this.hideDialog();
        }
    }

    destroy(): void {

        if (this._noResponseHandle) clearTimeout(this._noResponseHandle);
        if (this._fadeoutTimeout) clearTimeout(this._fadeoutTimeout);

        if (this._destroyHandle) clearTimeout(this._destroyHandle);
        super.destroy.apply(this, arguments as any);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.textLines = [];

        if (!this.domNode.parentElement) {
            this.UiModder.domConstruct.place(this.domNode, document.body);
        }

        this._initialParent = this.domNode.parentElement;

        if (this.displayType == "modal") {
            this._showModal();
        }

        this.setNewTarget(0, this._initialText);
        this.incrementStep(0);



        on(this.modalContainer, "cancel", lang.hitch(this, this._onCancelDialog));
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        
    }
}

export default mdsWidget(ProgressBar);